import { cn } from "../../../../lib/utils";
import { useBotbLeaderboardContext } from "../context";
import { useEffect } from "react";

export function MobileTabs() {
  const { activeTab, setActiveTab } = useBotbLeaderboardContext();
  const active = "text-primary border-b-primary";

  useEffect(() => {
    const updateHeaderHeight = () => {
      const header = document.querySelector(".botb-pass-header");
      if (header) {
        const height = header.getBoundingClientRect().height;
        document.documentElement.style.setProperty("--header-height", `${height}px`);
      }
    };
    updateHeaderHeight();
    window.addEventListener("resize", updateHeaderHeight);
  }, []);

  return (
    <div
      className={"w-full bg-white shadow-[0_1.5px_8px_0_rgba(0,0,0,0.20)] sticky z-40"}
      style={{ top: `var(--header-height)` }}>
      <div className={"grid grid-cols-2 gap-3 px-2.5"}>
        <button
          onClick={() => setActiveTab(0)}
          type="button"
          className={cn(
            `min-h-12 py-2.5 font-jost text-sm font-medium leading-5 flex-center gap-2 border-b-2 border-solid border-b-transparent ${activeTab === 0 ? active : "text-secondary"}`
          )}>
          <img
            src={"assets/images/leaderboard/leaderboard.png"}
            alt={"Leaderboard"}
            width={48}
            height={48}
            className="object-cover size-6"
          />
          <span>Leaderboard</span>
        </button>
        <button
          onClick={() => setActiveTab(1)}
          type="button"
          className={cn(
            `min-h-12 py-2.5 font-jost text-sm font-medium leading-5 flex-center gap-2 border-b-2 border-solid border-b-transparent ${activeTab === 1 ? active : "text-secondary"}`
          )}>
          <img
            src={"assets/images/leaderboard/earn.png"}
            alt={"Earn Points"}
            width={48}
            height={48}
            className="object-cover size-6"
          />
          <span>Earn Points</span>
        </button>
      </div>
    </div>
  );
}
